module.exports = __webpack_public_path__ + "img/number-expertos-3.de2200f5.png";